import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const BespokeSheetCard = () => {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setSt(r.data)); }, []);
  if (!st) return null;
  const fin = st.finishes || [];
  const setFin = (finishes) => setSt({ ...st, finishes });
  const move = (i, d) => { const a = [...fin]; [a[i], a[i + d]] = [a[i + d], a[i]]; setFin(a); };
  const save = async () => {
    try {
      const { data: cur } = await api.get("/settings");
      const { data } = await api.put("/settings", { ...cur, finishes: fin.filter((f) => f.name.trim()), length_delta_pct: Number(st.length_delta_pct) || 0, sheet_notes: st.sheet_notes });
      setSt(data); toast.success("Bespoke data sheet settings saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="bg-[var(--cream)] page-shadow p-8" data-testid="bespoke-settings-card">
      <p className="text-[11px] tracking-[0.3em] uppercase text-[var(--muted-ink)]">Bespoke style</p>
      <h2 className="text-base md:text-lg font-bold mt-1">Fabric &amp; leather options</h2>
      <p className="text-sm text-[var(--muted-ink)] mt-2 mb-5">Shown on every Bespoke data sheet. Each product only needs its price per option.</p>
      <div className="space-y-2">
        {fin.map((f, i) => (
          <div key={i} className="flex gap-2" data-testid={`finish-row-${i}`}>
            <Input value={f.name} onChange={(e) => setFin(fin.map((x, j) => (j === i ? { ...x, name: e.target.value } : x)))} placeholder="Option name" data-testid={`finish-name-${i}`} />
            <Input value={f.rate} onChange={(e) => setFin(fin.map((x, j) => (j === i ? { ...x, rate: e.target.value } : x)))} placeholder="e.g. Approx ₹ 1500/Meter" data-testid={`finish-rate-${i}`} />
            <Button size="icon" variant="ghost" disabled={!i} onClick={() => move(i, -1)} data-testid={`finish-up-${i}`}><ArrowUp size={13} /></Button>
            <Button size="icon" variant="ghost" disabled={i === fin.length - 1} onClick={() => move(i, 1)} data-testid={`finish-down-${i}`}><ArrowDown size={13} /></Button>
            <Button size="icon" variant="ghost" onClick={() => setFin(fin.filter((_, j) => j !== i))} data-testid={`finish-remove-${i}`}><Trash2 size={13} /></Button>
          </div>
        ))}
        <Button variant="outline" size="sm" onClick={() => setFin([...fin, { name: "", rate: "" }])} data-testid="finish-add-button"><Plus size={13} className="mr-1" />Add option</Button>
      </div>
      <div className="grid sm:grid-cols-[180px_1fr] gap-4 mt-6">
        <div><label className="text-[11px] tracking-[0.2em] uppercase">Length price delta %</label>
          <Input type="number" value={st.length_delta_pct} onChange={(e) => setSt({ ...st, length_delta_pct: e.target.value })} className="mt-1" data-testid="length-delta-input" />
          <p className="text-[11px] text-[var(--muted-ink)] mt-1">per 1 ft difference</p></div>
        <div><label className="text-[11px] tracking-[0.2em] uppercase">Footer notes (one per line)</label>
          <Textarea rows={3} value={(st.sheet_notes || []).join("\n")} onChange={(e) => setSt({ ...st, sheet_notes: e.target.value.split("\n") })} className="mt-1" data-testid="sheet-notes-input" /></div>
      </div>
      <Button onClick={save} className="mt-6" data-testid="save-bespoke-button">Save</Button>
    </section>
  );
};
